import { useState, useEffect, useCallback } from "react";
import throttle from "lodash.throttle";

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  function handleResize() {
    setWindowSize({
      width: document.body.clientWidth,
      height: document.body.clientHeight,
    });
  }
  const throttleHandler = useCallback(throttle(handleResize, 300), []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", throttleHandler);
      handleResize();

      return () => {
        window.removeEventListener("resize", throttleHandler);
      };
    }
  }, []);

  return windowSize;
}
